import axios from 'axios'

const postContactMessage = form =>
    axios.post('/api/v1/contact-messages', form).then(res => res.data)

export { postContactMessage }
